import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CustomCollectionsService from '@/services/CustomCollectionsServiceNew'
import DependentCollectionTableCard from './DependentCollectionTableCard'
import LoadingIndicator from '@/widgets/LoadingIndicator'


export default function DependentCollectionList({ parentCollectionDetails, item, addNewReturnPath }) {
	const { t } = useTranslation()
	// console.log(`TCL -> index.jsx:7 -> DependentCollectionList -> parentCollectionDetails:`, parentCollectionDetails)
	// console.log(`TCL -> index.jsx:7 -> DependentCollectionList -> item:`, item)

	const [loadingDeps, setLoadingDeps] = useState(false);
	const [error, setError] = useState(null);
	const [referenceCollectionStructure, setReferenceCollectionStructure] = useState([]);

	const collectionsReferencingParentCollection = async () => {
		// console.log(`Computing for parentCollectionDetails: `, parentCollectionDetails);
		setLoadingDeps(true)
		setError(null)
		const { data: referencingCollections, error: loadError } = await CustomCollectionsService.getDependentCollectionsFor(parentCollectionDetails.name);
		// console.log(`TCL -> index.jsx:21 -> loadDependents -> referencing collections:`, referencingCollections);
		// console.log(`TCL -> index.jsx:26 -> loadDependents -> filterField, filterValue:`, filterField, filterValue);

		if (loadError) {
			setError(loadError || 'Failed to load dependent collections')
			setLoadingDeps(false)
			return
		}

		let refStructure = [];
		referencingCollections.forEach(r => {
			// console.log(`TCL -> index.jsx:34 -> computing structure for r:`, r);
			let locaFieldName = r.referencingLocalField;

			refStructure.push({
				referenceCollectionName: r.referencingCollectionName,
				referenceCollectionId: r.referencingCollectionId,
				referenceCollectionFilterFieldName: r.referencingFieldName,
				referenceCollectionFilterFieldValue: item[locaFieldName],
			});
		});
		setReferenceCollectionStructure(refStructure);

		setLoadingDeps(false)
	}

	useEffect(() => {
		if (parentCollectionDetails?.name && item?._id) { collectionsReferencingParentCollection(); }
	}, [parentCollectionDetails])

	// console.log(`TCL -> index.jsx:10 -> DependentCollectionList -> referenceCollectionStructure:`, referenceCollectionStructure)
	// console.log(`TCL -> index.jsx:10 -> DependentCollectionList -> dependentNames:`, dependentNames)
	if (!item || referenceCollectionStructure.length === 0) return null

	if (loadingDeps) { return <LoadingIndicator message={t('singleCustomCollection.details.dependent.loading')} /> }

	return (
		<div className="space-y-6">
			{referenceCollectionStructure.map(dep => (
				<DependentCollectionTableCard
					key={dep.referenceCollectionName}
					parentItem={item}
					collectionName={dep.referenceCollectionName}
					collectionId={dep.referenceCollectionId}
					filterFieldName = {dep.referenceCollectionFilterFieldName}
					filterFieldValue = {dep.referenceCollectionFilterFieldValue}
					onSelectItem={(item) => {console.log(`Selected item from dependent collection ${dep.referenceCollectionName}:`, item)}}
					addNewReturnPath={addNewReturnPath}
				/>
			))}
		</div>
	)
}
